<template>
  <b-container>
    <b-alert :show="alert.message != ''" :variant="alert.variant" class="my-2">{{alert.message}}</b-alert>

    <section>
      <h3>Step 1: Select Problem Product & Product to be sent</h3>
      <b-form @submit=searchProducts>
        <b-form-row class="my-1">
          <b-col cols=2>
            <label for="problem-product">Problem Product:</label>
          </b-col>
          <b-col>
            <b-form-input id="problem-product" required v-model="problem.num" />
          </b-col>
          <b-col cols=2>
            <label for="rmahc-product">RMAHC Product:</label>
          </b-col>
          <b-col>
            <b-form-input id="rmahc-product" required v-model="rmahc.num" />
          </b-col>
        </b-form-row>
        <center class="my-1">
          <b-btn variant="secondary" type=submit>Select Products</b-btn>
        </center>
      </b-form>

      <b-row>
        <b-col>
          <table v-if="problem.product" class="table b-table">
            <thead>
              <th>Num</th>
              <th>Description</th>
            </thead>
            <tbody>
              <tr>
                <td>{{problem.product.num}}</td>
                <td>{{problem.product.description}}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col>
          <table v-if="rmahc.product" class="table b-table">
            <thead>
              <th>Num</th>
              <th>Description</th>
            </thead>
            <tbody>
              <tr>
                <td>{{rmahc.product.num}}</td>
                <td>{{rmahc.product.description}}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </section>

    <section v-if="rmahc.product && problem.product">
      <h3>Step 2: Find Orders within date range that need part sent</h3>
      <b-form @submit=searchOrders>
        <b-form-row class="my-1">
          <b-col cols=2>
            <label for="start">Start Date:</label>
          </b-col>
          <b-col>
            <b-form-input type=date id="start" required v-model="problem.startDate" />
          </b-col>
          <b-col cols=2>
            <label for="start">End Date:</label>
          </b-col>
          <b-col>
            <b-form-input type=date required v-model="problem.endDate" />
          </b-col>
        </b-form-row>
        <center class="my-1">
          <b-btn variant="secondary" type=submit>Find Matching Orders</b-btn>
        </center>
      </b-form>

      <div v-if=orders.length>
        <b-pagination :current-page="currentPage" :per-page="perPage" :total-rows="orders.length" v-model="currentPage" align=right />
        <b-table class="my-1" :fields="fields" :items="orders" :current-page="currentPage" :per-page="perPage" :busy="busy">
          <template slot="include" slot-scope="data">
            <input type="checkbox" v-model="data.item.include">
          </template>
          <template slot="num" slot-scope="data">
            <router-link :to="{ name: 'View Order', params: { id: data.item.num }}" target="_blank">
              {{ data.item.num }}
            </router-link>
          </template>
          <template slot="dateCreated" slot-scope="data">
            <NiceDate :value="data.item.dateCreated" />
          </template>
        </b-table>
      </div>
    </section>

    <section v-if="orders.length">
      <h3>Step 3: Additional information</h3>
      Select Qty of part being sent for EACH problem product, what type of issue, and Order Note for each RMAHC created
      <b-form @submit=submitBatchRmahc>
        <b-form-row class="my-1">
          <b-col cols=2>
            <label for="rmahc-qty">Send Qty:</label>
          </b-col>
          <b-col>
            <b-form-input type="number" id="rmahc-qty" required min=1 v-model="rmahc.qty" />
          </b-col>
          <b-col cols=2>
            <label for="rmahc-type">RMAHC Type:</label>
          </b-col>
          <b-col>
            <b-form-select :options="rmahcTypes" required v-model="rmahc.type" />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols=2>
            <label for="rmahc-note">RMAHC Note:</label>
          </b-col>
          <b-col>
            <b-form-textarea v-model="rmahc.note" />
          </b-col>
        </b-form-row>
        <center class="my-1">
          <b-btn variant=primary type=submit>Submit Batch RMAHC</b-btn>
        </center>
      </b-form>
    </section>
  </b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate';
import fishbowlHelper from '../../helpers/services/fishbowl';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
  },
  data() {
    return {
      problem: {
        num: '',
        found: true,
        product: null,
        startDate: null,
        endDate: null,
      },
      rmahc: {
        num: '',
        found: true,
        product: null,
        qty: 1,
        type: null,
        note: "",
      },
      rmahcTypes: [
        { text: 'Select One', value: null },
        { text: 'Missing', value: 'Missing' },
        { text: 'Wrong Part (WITHOUT return label)', value: 'WrongPart' },
        { text: 'Wrong Part (WITH return label)', value: 'WrongPart_Return' },
        { text: 'Quality (WITHOUT return label)', value: 'Quality', sendFromStock: true },
        { text: 'Quality (WITH return label)', value: 'Quality_Return', sendFromStock: true },
        { text: 'Misc. Issue', value: 'MiscIssue', userChoice: true }
      ],
      alert: {
        variant: 'danger',
        message: '',
      },
      fields: ['include', 'num', 'dateCreated', 'name', 'quantity'],
      orders: [],
      foundOrders: true,
      perPage: 10,
      currentPage: 1,
      busy: false,
    };
  },
  methods: {
    searchProducts(e) {
      e.preventDefault();
      this.alert.message = '';
      this.orders = [];

      axios.get(`${BASE_API}/fishbowl/product/${this.problem.num}`).then((response) => {
        if (response.data && response.data[0].num == this.problem.num) {
          this.problem.product = response.data[0]
        } else {
          this.alert.variant = 'warning';
          this.alert.message = "Problem Product not found";
        }
      }).catch((error) => {
          this.alert.variant = 'warning';
          this.alert.message = "Problem Product not found";
      });
      axios.get(`${BASE_API}/fishbowl/product/${this.rmahc.num}`).then((response) => {
        if (response.data && response.data[0].num == this.rmahc.num) {
          this.rmahc.product = response.data[0]
        } else {
          this.alert.variant = 'warning';
          this.alert.message = "RMAHC Product not found";
        }
      }).catch((error) => {
          this.alert.variant = 'warning';
          this.alert.message = "RMAHC Product not found";
      });;
    },
    searchOrders(e) {
      e.preventDefault();
      this.alert.message = '';
      if (this.problem.product == null || this.rmahc.product == null) {
        this.warning = "Click 'Find Products' first";
        return;
      }

      this.foundOrders = true;
      this.busy = true;
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/order/range`,
        data: this.problem,
      }).then((response) => {
        this.orders = response.data;
        this.orders.forEach( (o) => {
          o.include = true;
        });
        this.busy = false;
        if (this.orders.length == 0) {
          this.alert.variant = 'warning';
          this.alert.message = "No orders found";
        }
      });
    },
    submitBatchRmahc(e) {
      e.preventDefault();
      this.alert.message = '';
      if (!this.orders || this.orders.length == 0) {
        this.alert.variant = 'warning';
        this.alert.message = "Click 'Find Matching Orders' first";
        return;
      }

      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/champ/batch-rmahc`,
        data: {
          orders: this.orders.filter( (o) => o.include).map(order => ({
            num: order.num,
            qty: order.quantity,
            address: this.getAddress(order),
          })),
          problemProduct: this.problem.product,
          rmahcProduct: this.rmahc.product,
          rmahcType: this.rmahc.type,
          rmahcQty: this.rmahc.qty,
          rmahcNote: this.rmahc.note,
        }
      }).then((response) => {
        console.log("Issued Batch RMAHC: ", response.data);
        response.data.forEach( (rma) => this.infoAuditLog('submitted RMA',
          'Submit Batch RMAHC', rma[0], null, null) )
        this.alert.variant = 'success';
        this.alert.message = "Successfully issued batch RMAHC.";
      }).catch((error) => {
        console.error("Got Error: ", error);
        this.alert.variant = 'danger';
        this.alert.message = "Failed to issue Batch RMAHC, see console for more information.";
      });
    },
    getAddress(order) {
      let names = fishbowlHelper.getAccurateNames(order.name, order.address);
      names.city = order.city;
      names.zip = order.zip;
      names.region = order.state;
      names.country = order.country;
      names.carrier = order.carrier;
      names.shippingPriority = '';
      return names;
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/rma-hc/BatchRmaHc.vue